<template lang="pug">
.form-invoice.center
  form(@submit.prevent="" autocomplete="off")
    h2.title {{ title }}
    .form-section
      .list-items.dark.capitalize
        .item-history Status
        .item-history Upadate By
        .item-history Update At

      .list-items(v-if="dataOriginal.declinedBy")
        .item-history.capitalize Declined
        .item-history
          shNameUser(:dni="dataOriginal.declinedBy")
        .item-history {{ dateTime(dataOriginal.declinedAt) }}

      .list-items(v-if="dataOriginal.createdBy")
        .item-history.capitalize Created
        .item-history
          shNameUser(:dni="dataOriginal.createdBy")
        .item-history {{ dateTime(dataOriginal.createdAt) }}

      .list-items(v-if="dataOriginal.approvedBy")
        .item-history.capitalize Approved
        .item-history
          shNameUser(:dni="dataOriginal.approvedBy")
        .item-history {{ dateTime(dataOriginal.approvedAt) }}

      .list-items(v-if="dataOriginal.invoiceedBy")
        .item-history.capitalize Invoiced
        .item-history
          shNameUser(:dni="dataOriginal.invoiceedBy")
        .item-history {{ dateTime(dataOriginal.invoiceedAt) }}

    shActionButton(:isForm="true" :text="fillData ? 'Actualizar' : 'Guardar'" :textRunning="fillData ? 'Actualizando' : 'Guardando'" :action="sendForm")

  .right(v-if="fillData")
    shDeleteButton(@delete="deleteInvoice")
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import mDB from '@/mixins/db'
import gql from '@my/graphql'
import gqlInvoice from '@/graphql/invoice'
import shDeleteButton from '@/components/elements/DeleteButton'
import shInputList from '@/components/elements/InputList'
import shNameUser from '@/components/elements/NameUser'
import modals from '@my/store/modals'

export default {
  name: 'FormInvoice',

  mixins: [mForm, mFilters, mDB],

  components: { shDeleteButton, shInputList, shNameUser },

  props: {
    title: String,
    fillData: Boolean,
    dataOriginal: Object
  },

  data () {
    return {
      dataForm: {
        status: '',
        invoice: '',
        order: ''
      },
      resolver: 'invoice',
      key: 'invoice',
      gql: gqlInvoice,
      delete: ['invoice', 'order', 'status', 'observations', 'createdAt', 'approvedAt', 'invoiceedAt', 'declinedAt'],
      observation: '',
      types: [
        { key: '0', value: 'Derecho al rectracto (aplica hasta 5 días después de que le llegó el producto)' },
        { key: '1', value: 'El pedido llegó tarde' },
        { key: '2', value: 'El pedido no llegó' },
        { key: '3', value: 'No le gustó los productos' },
        { key: '4', value: 'No le quedaron los productos' },
        { key: '5', value: 'Producto fuera de stock' },
        { key: '6', value: 'Envió dinero de más' },
        { key: '7', value: 'Devolución de propina' },
        { key: '6', value: 'El producto llegó dañado o defectuoso' }
      ]
    }
  },

  created () {
    if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
  },

  methods: {
    sendForm () {
      if (!this.fillData) {
        this.newInvoice()
      } else {
        this.updateInvoice()
      }
    },

    newInvoice () {
      this.newData(this.gql, this.resolver, this.key)
    },

    updateInvoice () {
      this.updateData(this.gql, this.resolver, this.key)
    },

    deleteInvoice () {
      this.deleteData(this.gql, this.resolver, this.key)
    },

    setNameInvoiceMan () {
      if (!window.event.target.selectedIndex) {
        this.dataForm.nameInvoiceMan = ''
        return
      }
      this.dataForm.nameInvoiceMan = this.users[window.event.target.selectedIndex - 1].name
    },
    async addObservation () {
      const mutation = gqlInvoice.ADD_OBSERVATION
      const invoice = this.dataForm.invoice

      const response = await gql.mutate(mutation, { invoice, observation: this.observation })

      if (response) {
        modals.showMessage({ message: `Observación agregada` })
        this.observation = ''
      }
    }
  },

  computed: {
    conveyors () {
      return this.$store.state.variables.conveyors
    },
    users () {
      return this.$store.state.variables.users
    }
  },

  watch: {
    dataOriginal: {
      handler (val) {
        if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus">
.form-invoice
  position relative

.form-invoice .button-action:last-child
  margin-top 2em

.observation
  display flex
  justify-content space-between

.observation-observation
  flex-basis 40%
  text-align left
</style>



// WEBPACK FOOTER //
// src/components/pages/invoice/Form.vue